import { ExperienceEntityType } from 'modules/experience-core';

enum AllFilter {
  ALL = 'all',
}
export type EntityTypeFilterType = AllFilter | ExperienceEntityType;
export const EntityTypeFilter = {
  ...AllFilter,
  ...ExperienceEntityType,
};

export type PreviousEntitySelection = {
  experienceEntityType: ExperienceEntityType;
  experienceId: string;
  slug: string;
  label: string;
  listImage: string;
};
